"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAKING_COUNTER = exports.PREFIX = void 0;
exports.PREFIX = "staking";
exports.STAKING_COUNTER = "counter";
